import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import theme from '../../theme';

const YoutubeWhite = (props: SvgIconProps) => {
  const [isHover, setIsHover] = React.useState(false);
  return (
    <SvgIcon
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      {...props}
    >
      <path
        d="M29.2913 8.7248C29.1727 8.26487 28.9465 7.83972 28.6312 7.48445C28.316 7.12918 27.9208 6.85397 27.4782 6.68153C23.1945 5.03541 16.3724 5.04914 16 5.05109C15.6278 5.0481 8.8056 5.03534 4.52185 6.68153C4.0793 6.85396 3.68409 7.12915 3.36884 7.4844C3.05359 7.83965 2.82734 8.26477 2.70874 8.72468C2.38537 9.96601 2 12.2358 2 16.0001C2 19.7644 2.38537 22.0342 2.70868 23.2755C2.82725 23.7354 3.0535 24.1605 3.36875 24.5158C3.68401 24.8711 4.07922 25.1463 4.52179 25.3187C8.62256 26.8946 15.0495 26.9494 15.9177 26.9494C15.9952 26.9495 16.0048 26.9495 16.0823 26.9494C16.9512 26.9494 23.3776 26.8945 27.4782 25.3187C27.9207 25.1463 28.3159 24.8711 28.6312 24.5159C28.9464 24.1606 29.1727 23.7355 29.2913 23.2756C29.6146 22.0343 30 19.7644 30 16.0001C30 12.2359 29.6146 9.96607 29.2913 8.7248ZM20.2773 16.4161L14.2773 20.4161C14.202 20.4664 14.1145 20.4952 14.0241 20.4996C13.9337 20.5039 13.8438 20.4837 13.7641 20.441C13.6843 20.3983 13.6176 20.3347 13.571 20.2571C13.5245 20.1794 13.5 20.0906 13.5 20.0001V12.0001C13.5 11.9096 13.5245 11.8208 13.571 11.7432C13.6176 11.6655 13.6843 11.602 13.7641 11.5593C13.8438 11.5166 13.9337 11.4963 14.0241 11.5007C14.1145 11.5051 14.202 11.5339 14.2773 11.5841L20.2773 15.5841C20.3458 15.6298 20.402 15.6916 20.4408 15.7642C20.4797 15.8368 20.5 15.9178 20.5 16.0001C20.5 16.0824 20.4797 16.1635 20.4408 16.2361C20.402 16.3086 20.3458 16.3705 20.2773 16.4161Z"
        fill={isHover ? theme.palette.cyan : theme.palette.greyscale.white}
      />
    </SvgIcon>
  );
};

export default YoutubeWhite;
